import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "src/app/common/pipes/pipes.module";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { TabsComponent } from "src/app/shared/ui/tabs/tabs.component";
import { DragAndDropDirective } from "../../../directives/drag-and-drop.directive";
import { ConfigAreaConfirmDialogModule } from "../confirm/confirm.module";
import { CAContactSettingsTabComponent } from "./components/contact-settings/contact-settings.component";
import { CAModuleSettingsTabComponent } from "./components/module-settings/module-settings.component";
import { CAMunicipalSettingsTabComponent } from "./components/municipal-settings/municipal-settings.component";
import { ConfigAreaSettingsDialogComponent } from "./settings.component";

const materialModules = [
  MatDialogModule,
  MatButtonModule,
  MatIconModule,
  MatCheckboxModule,
  MatInputModule,
  MatFormFieldModule,
  MatDatepickerModule,
  MatMomentDateModule,
  MatDividerModule,
  MatExpansionModule,
  MatSelectModule,
  MatListModule,
  MatSlideToggleModule
];

@NgModule({
  declarations: [
    ConfigAreaSettingsDialogComponent,
    CAMunicipalSettingsTabComponent,
    CAContactSettingsTabComponent,
    CAModuleSettingsTabComponent,
    DragAndDropDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    ConfigAreaConfirmDialogModule,
    PipesModule,
    EneButtonModule,
    TabsComponent,
    ...materialModules
  ]
})
export class ConfigAreaSettingsDialogModule {}
